import fetchServer from "../controllers/fetchServer";

export const getPlans = async ({ isActive = true, limit = 0, offset = 0 }) => {
  // include both limit and offset in query string; backend should support pagination
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/plan?limit=${limit}&offset=${offset}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching plans");
  }

  return res.data || res;
};

export const getPlanPrivileges = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/plan/privileges",
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching privileges");
  }

  return res.data || res;
};

export const getPaystackPlans = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/plan/paystack",
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching Paystack plans");
  }

  return res.data || res;
};

export const togglePlanStatus = async ({ planId }) => {
  const res = await fetchServer({
    method: "PATCH",
    url: `/payment/v1/plan/changeStatus/${planId}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching plans");
  }

  return res.data || res;
};

export const getAddons = async ({ limit = 0, offset = 0 } = {}) => {
  const params = new URLSearchParams();
  params.set("limit", limit);
  params.set("offset", offset);

  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/addons?${params.toString()}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching addons");
  }

  return res.data || res;
};

export const toggleAddonStatus = async ({ addonId, isActive }) => {
  const res = await fetchServer({
    method: "PATCH",
    url: `/payment/v1/addons/changeStatus/${addonId}`,
    data: { isActive },
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong updating addon status");
  }

  return res.data || res;
};

export async function createAddonApi(addonBody) {
  let result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "POST",
    url: "/payment/v1/addons",
    data: addonBody,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res?.status === 201) {
          result = {
            return: 1,
            msg: "Addon created successfully",
            data: res.data?.data || {},
          };
        } else if (res?.data?.code && typeof res?.data?.detail === "string") {
          result = { return: 0, msg: res.data.detail, data: {} };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
      result = { return: 0, msg: "Network error occurred", data: {} };
    });

  return result;
}

export async function updateAddonApi(addonBody) {
  const { id, ...rest } = addonBody;
  let result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "PATCH",
    url: `/payment/v1/addons/${id}`,
    data: rest,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res?.status === 201) {
          result = {
            return: 1,
            msg: "Addon updated successfully",
            data: res.data?.data || {},
          };
        } else if (res?.data?.code && typeof res?.data?.detail === "string") {
          result = { return: 0, msg: res.data.detail, data: {} };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
      result = { return: 0, msg: "Network error occurred", data: {} };
    });

  return result;
}

export const deleteAddon = async (id) => {
  const res = await fetchServer({
    method: "DELETE",
    url: `/payment/v2/addons/${id}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong deleting addon");
  }

  return res.data || res;
};

export async function createPlanApi(planBody) {
  let result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "POST",
    url: "/payment/v1/plan",
    data: planBody,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res?.status === 201) {
          result = {
            return: 1,
            msg: "Plan created successfully",
            data: res.data?.data || {},
          };
        } else {
          if (res?.data?.code && typeof res?.data?.detail === "string") {
            result = { return: 0, msg: res.data.detail, data: {} };
          }
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
      result = { return: 0, msg: "Network error occurred", data: {} };
    });

  return result;
}
export async function updatePlanApi(planBody) {
  const { id, ...rest } = planBody;
  let result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "PATCH",
    url: `/payment/v1/plan/${id}`,
    data: rest,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res?.status === 201) {
          result = {
            return: 1,
            msg: "Plan created successfully",
            data: res.data?.data || {},
          };
        } else {
          if (res?.data?.code && typeof res?.data?.detail === "string") {
            result = { return: 0, msg: res.data.detail, data: {} };
          }
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
      result = { return: 0, msg: "Network error occurred", data: {} };
    });

  return result;
}

export async function createFeeApi(planBody) {
  let result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "POST",
    url: "/payment/v1/fee",
    data: planBody,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res?.status === 201) {
          result = {
            return: 1,
            msg: "Fee created successfully",
            data: res.data?.data || {},
          };
        } else {
          if (res?.data?.code && typeof res?.data?.detail === "string") {
            result = { return: 0, msg: res.data.detail, data: {} };
          }
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
      result = { return: 0, msg: "Network error occurred", data: {} };
    });

  return result;
}

export const getSubscribtionFees = async ({
  isActive = true,
  limit = 0,
  offset = 0,
} = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/fee?limit=${limit}&offset=${offset}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching fees");
  }

  return res.data || res;
};

export const getAccountSubscriptions = async ({
  limit = 0,
  offset = 0,
  searchBy,
  keyword,
} = {}) => {
  const params = new URLSearchParams();
  params.set("limit", limit);
  params.set("offset", offset);
  if (searchBy && keyword) {
    params.set("searchBy", searchBy);
    params.set("keyword", keyword);
  }

  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/accountSubscription?populate=account&populate=plan&${params.toString()}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching account subscriptions",
    );
  }

  return res.data || res;
};

export const getAccountSubscriptionByAccountId = async (accountId) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/accountSubscription/account/${accountId}?populate=account&populate=plan`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching account subscription detail",
    );
  }

  return res.data || res;
};

export const getSubscriptionTransactions = async ({
  limit = 10,
  offset = 0,
  searchBy,
  keyword,
  status,
  paymentMode,
} = {}) => {
  const params = new URLSearchParams();
  params.set("limit", limit);
  params.set("offset", offset);

  const filterBy = ["reason"];
  const filterValue = ["Subscription"];

  if (status) {
    filterBy.push("status");
    filterValue.push(status);
  }

  if (paymentMode) {
    filterBy.push("paymentMode");
    filterValue.push(paymentMode);
  }

  params.set("filterBy", filterBy.join(","));
  params.set("filterValue", filterValue.join(","));

  if (searchBy && keyword) {
    params.set("searchBy", searchBy);
    params.set("keyword", keyword);
  }

  const res = await fetchServer({
    method: "GET",
    url: `/payment/v2/transaction/detailedTransactions?populate=account&${params.toString()}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching transactions");
  }

  return res.data || res;
};
export const getFee = async (id) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/fee/${id}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong fetching fee");
  }

  return res.data || res;
};

export const deleteFee = async (id) => {
  const res = await fetchServer({
    method: "DELETE",
    url: `/payment/v1/fee/${id}`,
  });

  if (!res || res.error) {
    throw new Error(res?.error || "Something went wrong Deleting fee");
  }

  return res.data || res;
};

export async function updateFeeApi(payload) {
  const { id, ...rest } = payload;
  let result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "PATCH",
    url: `/payment/v1/fee/${id}`,
    data: rest,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200 || res?.status === 201) {
          result = {
            return: 1,
            msg: "Fee created successfully",
            data: res.data?.data || {},
          };
        } else {
          if (res?.data?.code && typeof res?.data?.detail === "string") {
            result = { return: 0, msg: res.data.detail, data: {} };
          }
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
      result = { return: 0, msg: "Network error occurred", data: {} };
    });

  return result;
}
